module.exports = __webpack_public_path__ + "img/12.50183059.png";